export default "__VITE_ASSET__DPry50vT__"